import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import useStore, { StoreState } from "../../context/useStore";

const Price = dynamic(() => import("./Price"), {
  suspense: true,
});

interface CoverProps {
  src: string;
  alt: string;
  ListPrice: number;
  Lock: boolean;
  index?: number;
}

const Cover: React.FC<CoverProps> = ({ alt, src, ListPrice, Lock, index }) => {
  const auth = useStore((state: StoreState) => state.auth);

  return (
    <div className="relative w-full aspect-[310/200]">
      {auth.login === false && Lock === true && (
        <div className="absolute w-full h-full top-0 right-0 z-[5] flex justify-center items-center">
          <div className="rounded-md bg-black text-white bg-opacity-80 px-5 py-2">
            <span className="text-base font-medium">Login Required</span>
          </div>
        </div>
      )}
      {auth.login === true && Lock === true && auth.verify == false && (
        <div className="absolute w-full h-full top-0 right-0 z-[5] flex justify-center items-center">
          <div className="rounded-md bg-black text-white bg-opacity-80 px-5 py-2">
            <span className="text-sm font-medium">
              Please Click Here To Verify Your Account
            </span>
          </div>
        </div>
      )}
      <Suspense fallback={<p>Loading...</p>}>
        <Image
          src={src}
          alt={alt}
          priority={index === 0}
          className={`object-cover w-full h-full ${
            (auth.login === false && Lock === true) ||
            (auth.login === true && Lock === true && auth.verify === false)
              ? "blur"
              : ""
          }`}
          sizes="(min-width: 1280px) 25vw, (min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
          layout="fill"
        />
      </Suspense>
      <Suspense
        fallback={
          <>
            <p>Loading...</p>
          </>
        }
      >
        <Price
          blur={
            auth.login === false && Lock === true
              ? true
              : auth.login === true && Lock === true && auth.verify == false
              ? true
              : false
          }
          ListPrice={ListPrice}
        />
      </Suspense>
    </div>
  );
};

export default React.memo(Cover);
